module.exports = __webpack_public_path__ + "static/media/01.848579f0.webp";